import React from 'react';

function Pagelogo3() {
  return (
    <div>
      <h1>Welcome to Page 1</h1>
    </div>
  );
}

export default Pagelogo3;
